export default __webpack_public_path__ + "static/O0021-72d071bbc3dcbc224e084febf89abd7b.png";